export enum ActionTypes {
  SHOW_LOADING_INDICATOR = 'LOADING_INDICATOR.SHOW_LOADING_INDICATOR',
  HIDE_LOADING_INDICATOR = 'LOADING_INDICATOR.HIDE_LOADING_INDICATOR',
}

export enum ReadyState {
  SHOW = 'LOADING_INDICATOR.SHOW',
  HIDE = 'LOADING_INDICATOR.HIDE',
}
